import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "dropdown" ]

  connect() {
    this.isOpen = false
  }

  toggle() {
    this.isOpen = !this.isOpen
    this.dropdownTarget.classList.toggle("hidden", !this.isOpen)
  }

  closeIfClickedOutside(event) {
    if (!this.element.contains(event.target)) {
      this.isOpen = false
      this.dropdownTarget.classList.add("hidden")
    }
  }
} 